import { loadConversationUI } from "./conversationUIStorage";
import { getConversationPersistenceService, getRuntimeContextResolver, getRuntimeGlobalState, } from "./conversationRuntimeService";
function getRuntimeDependencies() {
    return {
        globalState: getRuntimeGlobalState(),
        persistence: getConversationPersistenceService(),
        contextResolver: getRuntimeContextResolver(),
    };
}
function applySearchHistory(conversation, loadResult, options) {
    if (options.normalizeSearchHistory && loadResult.searchHistory) {
        conversation.searchHistory = options.normalizeSearchHistory(loadResult.searchHistory);
        return;
    }
    if (options.rebuildSearchHistoryFromMessages) {
        conversation.searchHistory = options.rebuildSearchHistoryFromMessages(loadResult.threads.values(), loadResult.metadata.documentId);
        return;
    }
    if (loadResult.searchHistory) {
        conversation.searchHistory = loadResult.searchHistory;
    }
}
export async function restoreInMemoryConversation(conversationId, options) {
    const { globalState } = getRuntimeDependencies();
    const conversation = globalState.conversationRegistry[conversationId];
    if (!conversation) {
        return null;
    }
    const existing = conversation.agentRegistry.getAgent(options.primaryAgentType);
    if (!existing && options.ensurePrimaryAgentRegistered) {
        options.ensurePrimaryAgentRegistered(conversation);
    }
    const uiState = await loadConversationUI(conversationId);
    if (!uiState || uiState.messages.length === 0) {
        return null;
    }
    return {
        conversationId,
        messages: uiState.messages,
    };
}
export async function restorePersistedConversation(conversationId, options) {
    const { globalState, persistence, contextResolver } = getRuntimeDependencies();
    try {
        const loadResult = await persistence.loadConversationForRestore(conversationId);
        if (!loadResult) {
            return null;
        }
        loadResult.contextEntries.forEach((entry, contextId) => {
            contextResolver.storeWithId(contextId, entry.content);
        });
        loadResult.imageEntries.forEach((entry, imageId) => {
            contextResolver.storeImage(imageId, entry.base64, entry.mimeType, entry.metadata);
        });
        const conversation = globalState.createConversation(conversationId, loadResult.metadata.documentId, loadResult.metadata.origin === "mainTaskpane" ? "mainTaskpane" : "other");
        applySearchHistory(conversation, loadResult, options);
        const existing = conversation.agentRegistry.getAgent(options.primaryAgentType);
        if (!existing && options.ensurePrimaryAgentRegistered) {
            options.ensurePrimaryAgentRegistered(conversation);
        }
        const threadManager = conversation.agentRegistry.threadManager;
        loadResult.threads.forEach((thread) => {
            threadManager.restoreThread(thread);
        });
        const uiState = await loadConversationUI(conversationId);
        if (!uiState || uiState.messages.length === 0) {
            return null;
        }
        return {
            conversationId,
            messages: uiState.messages,
        };
    }
    catch (error) {
        console.error("[ConversationRestore] Error restoring conversation:", error);
        return null;
    }
}
